import React from "react";
import styled from "styled-components";
import { Plural } from "@lingui/macro";
import {
  DisplaySmall,
  SiteOutline,
  InsightsListOutline,
  EquipsItemOutline,
  CalendarListOutline,
  spacing,
  color,
} from "@conserveit/blocks";
import { TimeRange } from "../utils/types";

interface Props {
  siteCount: number;
  insightsCount: number;
  equipCount: number;
  timeRange: string | TimeRange;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
`;
const Column = styled.div`
  display: inline-flex;
  flex: 1;
`;

const Left = styled(Column)`
  margin-right: auto;
`;

const Center = styled(Column)`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;

const Right = styled(Column)`
  margin-left: auto;
`;

const StyledDisplaySmall = styled(DisplaySmall)`
  display: flex;
  align-items: center;
  margin: 0 ${spacing.tight};
  color: ${color.theme.typography.ink};
`;

const Icon = styled.div`
  margin: ${spacing.extraTight} ${spacing.tight} ${spacing.extraTight} 0;
`;

export const InfoBar: React.FunctionComponent<Props> = ({
  siteCount,
  insightsCount,
  equipCount,
  timeRange,
}) => {
  return (
    <Container>
      <Left />
      <Center>
        <StyledDisplaySmall as="span">
          <Icon>
            <SiteOutline fillColor={color.theme.supportingColor.subdued} />
          </Icon>
          <strong>
            {siteCount}{" "}
            <Plural
              id="analysis.sites"
              value={siteCount}
              one="Site"
              other="Sites"
            />
          </strong>
        </StyledDisplaySmall>
        <StyledDisplaySmall as="span">
          <Icon>
            <InsightsListOutline
              fillColor={color.theme.supportingColor.subdued}
            />
          </Icon>
          <strong>
            {insightsCount}{" "}
            <Plural
              id="analysis.analyses"
              value={insightsCount}
              one="Insight"
              other="Insights"
            />
          </strong>
        </StyledDisplaySmall>
        <StyledDisplaySmall as="span">
          <Icon>
            <EquipsItemOutline
              fillColor={color.theme.supportingColor.subdued}
            />
          </Icon>
          <strong>
            {equipCount}{" "}
            <Plural
              id="analysis.equips"
              value={equipCount}
              one="Equip"
              other="Equips"
            />
          </strong>
        </StyledDisplaySmall>
        <StyledDisplaySmall as="span">
          <Icon>
            <CalendarListOutline
              fillColor={color.theme.supportingColor.subdued}
            />
          </Icon>
          <strong>{timeRange}</strong>
        </StyledDisplaySmall>
      </Center>
      <Right />
    </Container>
  );
};
